import type { BranchKey } from '@festina-life/api'
import { assertNotEmpty } from '@festina-life/core'
import { useCallback, useMemo } from 'react'

import { useAllConciseBranches } from '../../../../uiModels/branches/useAllConciseBranches'
export const useNonAncestorBranchesOnServer = (forBranch: BranchKey) => {
  const allBranches = useAllConciseBranches()
  const branchesForServer = allBranches?.[forBranch.server]
  const getConciseBranch = useCallback(
    (branchName: string) => {
      const branch = branchesForServer?.find(
        (conciseBranch) => conciseBranch.name === branchName,
      )
      assertNotEmpty(branch)

      return branch
    },
    [branchesForServer],
  )

  assertNotEmpty(branchesForServer) // At least forBranch should exist inside the server branches

  return useMemo(
    function getAllBranchForServerExceptSelfAndAncestors() {
      let sourceBranch = getConciseBranch(forBranch.name)
      const candidateBranches = branchesForServer.filter(
        (conciseBranch) => conciseBranch.name !== forBranch.name,
      )

      while (sourceBranch.baseBranchName) {
        const baseBranch = getConciseBranch(sourceBranch.baseBranchName)
        candidateBranches.splice(candidateBranches.indexOf(baseBranch), 1)
        sourceBranch = baseBranch
      }

      return candidateBranches
    },
    [branchesForServer, forBranch.name, getConciseBranch],
  )
}
